import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { Checkbox, createMuiTheme, FormControlLabel, FormGroup, FormLabel, InputAdornment, MuiThemeProvider, Snackbar, Switch, TableCell, TextField, Tooltip, Typography, withStyles } from "@material-ui/core";
import AddPasien from './addPasien';
import Loader from 'react-loader-spinner'
import { useSelector, useDispatch } from 'react-redux';
import EditPasien from './editPasien';
import FilterPasien from './filterPasien';
import filterIcon from '../../assets/ic_search@3x.png';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import editIcon from '../../assets/1@3x.png';
import { format } from 'date-fns';
import CloseImage from '../../assets/ic_close.png';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import InputMask from 'react-input-mask';
import Autocomplete from '@material-ui/lab/Autocomplete';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

// const options = ct.customOptions()

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function Pasien(props) {
    const dispatch = useDispatch()
    const patient = useSelector((store) => store.patientReducer.patient);
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleStatus, setVisibleStatus] = React.useState(false);
    const [detail, setDetail] = React.useState([])
    const [listPatient, setListPatient] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [rowData, setRowData] = React.useState(null);
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const [validTo, setValidTo] = React.useState(new Date());
    const [validFrom, setValidFrom] = React.useState(null);
    const [page, setPage] = React.useState(1)
    const [limit, setLimit] = React.useState(10)
    const [dataCount, setDataCount] = React.useState(10)
    const [popUpFilter, setPopUpFilter] = React.useState(false)

    const [userID, setUserID] = React.useState("")
    const [namaPasien, setNamaPasien] = React.useState("")
    const [KTP, setKTP] = React.useState("")
    const [rekamMedis, setRekamMedis] = React.useState("")
    const [tglLahir, setTglLahir] = React.useState(null);
    const [gender, setGender] = React.useState(null)
    const [phone, setPhone] = React.useState("")
    const [mobilePhone, setMobilePhone] = React.useState("")
    const [alamat, setAlamat] = React.useState("")
    const listGender = [
        { value: 'Laki-laki', id: 'L' },
        { value: 'Perempuan', id: 'P' },
    ]

    const [formated, setFormated] = React.useState("")

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let idx = response.data.data.findIndex((val) => val.param_code === "MEDICAL_RECORD_NO_FORMAT")
                    console.log(idx);
                    if (idx > -1) {
                        setFormated(response.data.data[idx].param_value)
                    }
                }
            }
        })
    }

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        setDetail(rowData);
        setVisibleDetail(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    React.useEffect(() => {
        props.setShowNotif(true)
        // getDataPasien()
        getData(page, limit, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
        setLoading(true)
        getPermission(props)
        getParam()
    }, [])

    const getData = (a, b, c, d, e, f, g, h, i, j, k, l, m) => {
        let page = a ? `page=${a}` : ''
        let limit = b ? `&per_page=${b}` : ''
        let namaPasien = c !== "" ? `&keyword=${c}` : ''
        let ktp = d
        let noRM = e
        let filter = []
        if (d && d !== "") {
            filter.push(`"identity_no":"${d}"`)
        }
        if (e && e !== "") {
            filter.push(`"medical_record_no":"${e}"`)
        }
        if (f) {
            filter.push(`"date_of_birth":"${format(new Date(f), 'yyyy-MM-dd')}"`)
        }
        if (g) {
            filter.push(`"gender":"${g.id}"`)
        }
        if (h && h !== "") {
            filter.push(`"address":"${h}"`)
        }
        if (i && i !== "") {
            filter.push(`"mobile_phone":"${i}"`)
        }
        if (j && j !== "") {
            filter.push(`"phone":"${j}"`)
        }
        if (k && k !== "") {
            filter.push(`"user_id":"${k}"`)
        }
        console.log(JSON.stringify(filter));
        api.create().getListPatientFilter(`filter={${filter.join(",")}}&${page}${limit}${namaPasien}`
        ).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item, index) => {
                        let arr = [
                            item.user_id === null ? "-" : item.user_id,
                            item.is_jkn_patient === 0 ? 'Tidak' : 'Ya',
                            item.identity_no === null ? "" : item.identity_no,
                            item.name,
                            item.phone,
                            item.mobile_phone,
                            item.gender === "L" ? "Laki-Laki" : "Perempuan",
                            format(new Date(item.date_of_birth), 'dd MMM yyyy'),
                            item.address === null ? "" : item.address,
                            item.is_verified === 1 ? "Terverfikasi" : "Belum Verfikasi",
                            item.status === 1 ? "Active" : 'Inactive',
                            item.id
                        ]
                        data.push(arr)
                    })
                    setDataCount(response.data.total_data)
                    setListPatient(data)
                    setLoading(false)
                    forceUpdate()
                }

            }
        })
    }

    const handleFilter = () => {
        // if (tglMulai !== null && tglSelesai === null) {
        //     console.log("tes");
        //     setErrorTglSelesai(true)
        //     setTextErrorTglSelesai("Tanggal Selesai wajib diisi")
        // } else {
        getData(page, limit, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
        // }
    }

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getDataPasien = () => {
        api.create().getListPatient().then(response => {
            console.log(response)
            if (response.data) {
                let listPatient = response.data.data.map((item, index) => {
                    return [
                        item.user_id === null ? "-" : item.user_id,
                        item.identity_no === null ? "" : item.identity_no,
                        item.name,
                        item.phone,
                        item.mobile_phone,
                        item.gender === "L" ? "Laki-Laki" : "Perempuan",
                        format(new Date(item.date_of_birth), 'dd MMM yyyy'),
                        item.address === null ? "" : item.address,
                        item.is_verified === 1 ? "Terverfikasi" : "Belum Verfikasi",
                        item.status === 1 ? "Active" : 'Inactive',
                        item.id
                    ]
                })
                setListPatient(listPatient)
                setLoading(false)
                forceUpdate()
            } else {
                setLoading(false)
            }
        })
    }

    const createPasien = (payload) => {
        api.create().createPatient(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    getDataPasien()
                } else {
                    alert(response.data.message)
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const updatePatient = (payload) => {
        console.log(payload);
        api.create().updatePatient(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    getData(page, limit, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
                } else {
                    alert(response.data.message)
                }
            }
        })
    }

    const changeStatus = () => {
        console.log(rowData);
        let payload = {
            "id": rowData[11],
            "status": rowData[10] === "Active" ? 0 : 1
        }
        api.create().changeStatusPatient(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    onClose()
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    getData(page, limit, "", "")
                }
            }
        })
    }

    const handleStatus = ({ rowData }) => {
        console.log(rowData);
        setVisibleStatus(true)
        setRowData(rowData)
        // console.log(rowData);
    }

    const columns = [
        {
            name: "user_id",
            label: "User ID",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, backgroundColor: 'white', }}>
                        <Typography style={{ textAlign: 'center', fontWeight: 600 }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "Pasien BPJS",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "No. KTP",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "pasien",
            label: "Nama Pasien",
            options: {
                sort: true,
            }
        },
        {
            name: "No. Telepon",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "No. Handphone",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "geder",
            label: "Jenis Kelamin",
            options: {
                sort: true,
            }
        },
        {
            name: "Tanggal Lahir",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "Alamat Pasien",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "Status",
            options: {
                sort: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                filter: false,
                sort: false,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontWeight: 600 }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {update && (
                                <LightTooltip title={"Edit"} arrow>
                                    <button
                                        style={{
                                            backgroundColor: "transparent",
                                            fontSize: 20,
                                            outline: 'none',
                                            borderColor: 'transparent'
                                        }
                                        }
                                        onClick={() => handleSeeDetail(tableMeta)}
                                    >
                                        <img src={editIcon} style={{ width: 30, height: 30 }} />
                                    </button>
                                </LightTooltip>
                            )}

                            {deleted && (
                                <LightTooltip title={`${tableMeta.rowData[10]}`} arrow>
                                    <button style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}
                                        onClick={() => handleStatus(tableMeta)}>
                                        <IconSwitch checked={tableMeta.rowData[10] === 'Active' ? true : false} />
                                    </button>
                                </LightTooltip>
                            )}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        }];


    const options = {
        sort: true,
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: false,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: limit,
        count: dataCount,
        responsive: 'scrollMaxHeight',
        serverSide: true,
        onFilterChange: (columnChanged, filterList, c, d, e, f, g) => {
            // console.log(columnChanged, filterList, c, d, e, f, g);
            props.setDataReservasi(e === undefined ? [] : e)
            if (columnChanged === null) {
                setListPatient(null)
                getData(page, limit, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
            }
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    setLoading(true)
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
                    break;
                case 'changeRowsPerPage':
                    setLoading(true)
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, namaPasien, KTP, rekamMedis, tglLahir, gender, alamat, mobilePhone, phone, userID)
                    break;
                case 'sort':
                    setLoading(true)
                    sorting(tableState)
                    break;
                default:
                    break;
            }
        }
    };

    const sorting = (tableState) => {
        let arr = listPatient
        arr.sort(function (a, b) {
            if (String(tableState.announceText).includes('descending')) {
                return a[tableState.activeColumn].localeCompare(b[tableState.activeColumn]) ;
            } else {
                return b[tableState.activeColumn].localeCompare(a[tableState.activeColumn]) ;
            }
        });
        setListPatient(arr)
        setTimeout(() => {
            setLoading(false)
        }, 200);
        forceUpdate()
        console.log(arr, tableState);
    };

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        setVisibleDetail(false);
        setVisibleFilter(false);
        setVisibleStatus(false)
    };


    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    {create && (
                        <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', margin: '5px 0' }}
                            onClick={() => onOpen()}
                        >
                            <div style={{ display: 'flex' }}>
                                <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah Pasien</Typography>
                            </div>
                        </button>
                    )}
                </div>
                <button onClick={() => setPopUpFilter(true)} style={{ height: 40, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', padding: '0 20px', alignSelf: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {/* <img style={{ width: 16, height: 16, marginRight: 7 }} src={icFilter} /> */}
                        <Typography style={{ fontSize: 14, margin: 'auto', margin: '0 3px', color: 'white' }}>Filter Data</Typography>
                    </div>
                </button>
            </div>
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
            {read && (
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={listPatient}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}


            {visibleCreate ?
                <AddPasien
                    onClose={onClose}
                    getData={getDataPasien}
                    createPasien={createPasien}
                /> : null}
            {visibleDetail ?
                <EditPasien
                    onClose={onClose}
                    detail={detail}
                    updatePatient={updatePatient}
                /> : null}
            {visibleFilter ?
                <FilterPasien
                    onClose={onClose}
                /> : null}
            {visibleStatus && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => onClose()}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin mengganti status Pasien tersebut?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => onClose()}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => changeStatus()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {popUpFilter && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white">
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 30, borderTopLeftRadius: 30, backgroundColor: '#f5f5f5' }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, }}>Filter</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setPopUpFilter(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ backgroundColor: '#f5f5f5', padding: '20px' }}>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '95%' }}
                                    size="small"
                                    label="User ID"
                                    onChange={(e) => {
                                        setUserID(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={userID}
                                />
                            </div>
                            <div className="column-2">
                                <TextField
                                    style={{ width: '95%' }}
                                    size="small"
                                    label="Nama Pasien"
                                    onChange={(e) => {
                                        setNamaPasien(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={namaPasien}
                                />
                            </div>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '95%' }}
                                    size="small"
                                    label="No. KTP"
                                    onChange={(e) => {
                                        setKTP(e.target.value)
                                    }}
                                    InputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                    value={KTP}
                                />
                            </div>
                            <div className="column-2">
                                <InputMask
                                    mask={String(formated).split('#').join('*')}
                                    value={rekamMedis}
                                    onChange={(e) => {
                                        setRekamMedis(e.target.value)
                                        forceUpdate()
                                    }}
                                >
                                    {() =>
                                        <TextField
                                            style={{ width: '95%' }}
                                            id="rekam"
                                            name="rekam"
                                            label="No. Rekam Medis Pasien"
                                            placeholder={"input No. Rekam"}
                                            required={true}
                                            value={rekamMedis}
                                            // onChange={(e) => {
                                            //     setRekamMedis(e.target.value)
                                            //     forceUpdate()
                                            // }}
                                            InputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        />
                                    }
                                </InputMask>
                            </div>
                            <div className="column-1">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="tanggal Lahir"
                                        label="Tanggal Lahir"
                                        required={true}
                                        format="dd/MM/yyyy"
                                        maxDate={new Date()}
                                        value={tglLahir}
                                        onChange={(date) => {
                                            setTglLahir(date)
                                            forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '95%', marginTop: 0 }}
                                        inputProps={{ style: { fontSize: 14 } }}
                                        InputProps={{
                                            style: {
                                                fontSize: 14,
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <div className="column-2" style={{ marginLeft: 10 }}>
                                <Autocomplete
                                    options={listGender}
                                    getOptionLabel={(option) => option.value}
                                    disableClearable
                                    style={{ width: '95%' }}
                                    id="tipe"
                                    onChange={(event, newInputValue) => {
                                        setGender(newInputValue)
                                        forceUpdate()
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            inputProps={{ style: { fontSize: 14 } }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            label="Jenis Kelamin"
                                        />
                                    }
                                    value={gender}
                                />
                            </div>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '95%' }}
                                    id="noHp"
                                    name="noHp"
                                    label="No. Handphone Pasien"
                                    placeholder={"Input No. hp"}
                                    value={mobilePhone}
                                    onChange={(e) => {
                                        setMobilePhone(String(e.target.value).replace(/^(?!00[^0])0/, ''))
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        maxLength: 12,
                                        fontSize: 14,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5 }}>+62</InputAdornment>,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2">
                                <TextField
                                    style={{ width: '95%', marginTop: 2 }}
                                    id="alamat"
                                    name="alamat"
                                    label="Alamat"
                                    placeholder={"Alamat"}
                                    value={alamat}
                                    onChange={(e) => {
                                        setAlamat(e.target.value)
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '95%' }}
                                    id="notelepon"
                                    name="notelepon"
                                    label="No. Telepon Pasien"
                                    placeholder={"Input No. Telepon"}
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(String(e.target.value).replace(/^(?!00[^0])0/, ''))
                                        forceUpdate()
                                    }}
                                    inputProps={{
                                        maxLength: 12,
                                        fontSize: 14,
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => {
                                    setNamaPasien("")
                                    setKTP("")
                                    getData(page, limit, "", "")
                                    // setPoliklinik([])
                                    // setTglMulai(null)
                                    // setTglSelesai(null)
                                    // setNamaPasien("")
                                    // setIdReservasi("")
                                    // setOpsiPembayaran([])
                                    // setStatus([])
                                    // setReservasiVia([])
                                    // setNoAntri("")
                                    // setReason("")
                                    forceUpdate()
                                    setPopUpFilter(false)
                                }} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Reset</Typography>
                                </div>
                                <div onClick={(e) => handleFilter()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}